export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImM0NDcyNWU3LWE3NDctNDQwMi04Y2VhLWNlYjA5MGFhODY0MCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.DoJXdiP+l1uNcMHFYhL0jsvIdKLEN7b+w/YEKIzrccBAngoGqWuO4oUdlA3hLtOQ5HP6G4wMczby2ikcDLZbHfI+vZ/axNlLQvIHNd3AZawup+k5ixvWvRv0XYlETD2jDBrgJQ==';
